export function generateSlugFromName(input: string): string {
  let lowerCaseString = input.toLowerCase();
  //* Replace spaces with hyphens
  let replacedSpacesString = lowerCaseString.replace(/\s+/g, "-");
  //* Remove all characters that are not lowercase letters, numbers, or hyphens
  let cleanedString = replacedSpacesString.replace(/[^a-z0-9-]/g, "");
  //*  Replace multiple consecutive hyphens with a single hyphen
  let finalString = cleanedString.replace(/-+/g, "-");
  return finalString;
}
